import { Box, Chip, InputLabel, MenuItem, TextField, Typography } from '@mui/material'
import React, { ChangeEvent, ChangeEventHandler, useEffect, useState } from 'react'

interface optionProps {
  id: number | string
  name: number | string
  value: number | string | object
  disable?: boolean
}

interface FieldProps {
  variant?: 'filled' | 'outlined' | 'standard'
  label?: string
  fieldClass?: string
  divClass?: string
  defaultValue?: string | number | any
  placeholder?: string
  error?: boolean
  showChip?: boolean
  setDefault?: boolean
  chipBorderStyle?: string
  chipStyle?: React.CSSProperties
  useValue?: boolean
  helperText?: string
  customHeight?: string
  inputLabel?: any
  validation?: object
  options: optionProps[]
  handleChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined
  RenderCustomLabel?: React.ElementType
  changeSelectColor?:boolean
  disabled?: boolean
}

const SelectField = ({
  changeSelectColor,
  label = '',
  inputLabel = '',
  defaultValue,
  chipStyle,
  placeholder,
  helperText,
  useValue = false,
  error,
  validation,
  variant = 'outlined',
  fieldClass = '',
  divClass = '',
  options = [
    {
      id: 0,
      name: '',
      value: ''
    }
  ],
  customHeight,
  handleChange,
  RenderCustomLabel,
  showChip = false,
  setDefault = false,
  disabled = false
}: FieldProps) => {
  const [selectedValue, setSelectedValue] = useState<string[]>([])
  const [hasSelection, setHasSelection] = useState(false)

  const onChange = (e: any) => {
    if (handleChange) {
      handleChange(e)
      setSelectedValue([e.target.value.toString()])
      setHasSelection(!!e.target.value)
    }
  }

  useEffect(() => {
    if ((defaultValue && showChip) || setDefault) {
      setSelectedValue([String(defaultValue)])
      setHasSelection(!!defaultValue)
    }
  }, [defaultValue, setDefault, showChip])

  return (
    <div id={showChip ? 'test-filter-override' : ''} className={divClass}>
      {RenderCustomLabel && <RenderCustomLabel />}
      {inputLabel && (
        <InputLabel className="font-semibold text-secondary-main text-[0.875rem]">
          {inputLabel}
        </InputLabel>
      )}
      <TextField
        label={label}
        variant={variant}
        {...validation}
        select
        disabled={disabled}
        defaultValue={defaultValue}
        color="primary"
        autoComplete="off"
        placeholder={placeholder}
        error={error}
        helperText={helperText}
        InputProps={{
          className: `rounded-[0.625rem] border-icon-darkgray ${
            customHeight ? customHeight : 'h-[3.375rem]'
          } ${fieldClass}`,
          style: {
            backgroundColor: changeSelectColor && ( hasSelection || defaultValue) ? '#07004D29' : 'transparent' 
          },
          startAdornment:
            showChip &&
            selectedValue?.map(item => (
              <Chip
                key={item}
                tabIndex={-1}
                label={item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()}
                style={chipStyle}
              />
            ))
        }}
        fullWidth
        onChange={onChange}
      >
        {placeholder && (
          <MenuItem
            className="hidden rounded-xl"
            disabled
            key={placeholder}
            value={placeholder}
            data-modal="true"
          >
            <Typography style={{ color: ' rgba(0, 0, 0, 0.44)' }}>
              {(placeholder || label) ?? 'Select'}
            </Typography>
          </MenuItem>
        )}
        {options?.map((item: optionProps) => (
          <MenuItem
            data-modal="true"
            color={item?.name === label ? 'error' : ''}
            disabled={item?.disable ?? false}
            key={item?.id}
            value={item?.id}
          >
            {item?.name}
          </MenuItem>
        ))}
      </TextField>
    </div>
  )
}

export default SelectField